import { Skeleton, type SxProps, type Theme, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import CountUpCard from "../../../../../Components/CountUp/CountUpCard";
import CardTitle from "../Components/CardTitle";
import { useClusterDashboardContext } from "../Table/context";

const boxSx: SxProps<Theme> = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

const cardSx: SxProps<Theme> = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

const commonCountupProps = {
  sx: { ...boxSx },
  cardSx: { ...cardSx },
  duration: 1,
  decimals: 2,
  text: "",
  contentStyle: { fontSize: 36 },
  spacing: 1,
  prefix: "$",
};

const Fsk8sOverviewDashboard = () => {
  const { dashboardClusters, loading } = useClusterDashboardContext();

  const { cost, waste, previousCost, previousWaste } = dashboardClusters.summary ?? {
    cost: 0,
    waste: 0,
    previousCost: 0,
    previousWaste: 0,
  };

  if (loading) {
    return <Skeleton variant="rectangular" height={172} />;
  }

  return (
    <Grid container spacing={2} minHeight={172}>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <CountUpCard
          {...commonCountupProps}
          childAboveContent={<CardTitle>Total spend</CardTitle>}
          number={cost}
          decimals={2}
          childBelowText={
            <Typography variant="body2" color="text.secondary">
              Up {previousCost > 0 ? parseFloat(((cost - previousCost) / previousCost).toFixed(2)) * 100 : 100}% vs.
              last week
            </Typography>
          }
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 6 }}>
        <CountUpCard
          {...commonCountupProps}
          childAboveContent={<CardTitle>Pod waste</CardTitle>}
          number={waste}
          decimals={2}
          childBelowText={
            <Typography variant="body2" color="text.secondary">
              Up {previousWaste > 0 ? parseFloat(((waste - previousWaste) / previousWaste).toFixed(2)) * 100 : 100}% vs.
              last week
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
};

export default Fsk8sOverviewDashboard;
